import { Button } from "@fluentui/react-components"
import { Add32Filled } from "@fluentui/react-icons";
import { Dispatch, SetStateAction } from "react";
import { useAppSelector } from "../pgStore";

interface HomePageActionsProps {
	showModal: boolean,
	setModal: Dispatch<SetStateAction<boolean>>
}

export default function HomePageActions(props: HomePageActionsProps) {
	const isOwner = useAppSelector((state) => state.userSlice.username === 'SneakySquid');

	if (!isOwner) {
		return <></>
	}

	return (
		<>
			<Button
				title="Add a Story"
				appearance="primary"
				icon={
					<Add32Filled />
				}
				onClick={() => { props.setModal(!props.showModal); }}
			>

			</Button>
		</>
	)
}











